import { observable } from "@legendapp/state";

import { activeOrganization$ } from "../organizations";
import type { Member } from "./members.types";

export const members$ = observable<Member[]>(
  () => activeOrganization$.members.get() ?? [],
);
